// import React from "react";
// import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

// // Define styles
// const portraitStyles = StyleSheet.create({
//   page: {
//     paddingVertical: 20,
//     paddingHorizontal: 15,
//     position: "relative",
//   },
//   header: {
//     marginBottom: 0,
//     textAlign: "center",
//   },
//   title: {
//     fontSize: 14,
//     fontWeight: "bold",
//     marginBottom: 4,
//   },
//   shopInfo: {
//     fontSize: 10,
//     marginBottom: 10,
//   },
//   divider: {
//     borderBottomWidth: 1,
//     borderBottomColor: "#000",
//     marginVertical: 1,
//     width: "100%",
//   },
//   thickDivider: {
//     borderBottomWidth: 2,
//     borderBottomColor: "#000",
//     marginVertical: 2,
//     width: "100%",
//   },
//   reportTitle: {
//     fontSize: 12,
//     fontWeight: "bold",
//     marginTop: 2,
//     marginBottom: 4,
//   },
//   table: {
//     display: "table",
//     width: "100%",
//     marginTop: 2,
//   },
//   tableRow: {
//     flexDirection: "row",
//   },
//   tableColHeader: {
//     paddingVertical: 4,
//     paddingHorizontal: 2,
//     color: "#000232",
//     textAlign: "center",
//     fontSize: 10,
//     fontWeight: "bold",
//     borderWidth: 0.5,
//     borderColor: "#000",
//     backgroundColor: "#E7EBF4",
//     whiteSpace: "nowrap",
//   },
//   tableColSl: { flex: 0.4, padding: 4, textAlign: "center", fontSize: 9 },
//   tableColDate: { flex: 1, padding: 4, textAlign: "center", fontSize: 9 },
//   tableProductName: { flex: 2, padding: 4, textAlign: "left", fontSize: 9 },
//   tableColImei: { flex: 1.5, padding: 4, textAlign: "left", fontSize: 9 },
//   tableColPurchasePrice: { flex: 1, padding: 4, textAlign: "center", fontSize: 9 },
//   tableColPurchaseInvoice: { flex: 1, padding: 4, textAlign: "center", fontSize: 9 },
//   tableColSalePrice: { flex: 1, padding: 4, textAlign: "center", fontSize: 9 },
//   tableColSaleInvoice: { flex: 1, padding: 4, textAlign: "center", fontSize: 9 },
//   tableColVendor: { flex: 1, padding: 4, textAlign: "center", fontSize: 9 },
//   tableRowAlternate: { backgroundColor: "#F5F5F5" },
//   grandTotalRow: {
//     backgroundColor: "#E7EBF4",
//     fontWeight: "bold",
//     fontSize: 9,
//     textAlign: "center",
//     padding: 4,
//   },
//   footer: {
//     position: "absolute",
//     bottom: 15,
//     left: 0,
//     right: 0,
//     flexDirection: "row",
//     justifyContent: "space-around",
//     fontSize: 9,
//   },
// });

// // PDF document component for portrait
// const ImeiReportPrintPagePortrait = ({ reports, startDate, endDate }) => {
//   const items = Object.entries(reports ?? {}).flatMap(([brandName, items]) => items);

//   const purchasePriceTotal = items.reduce(
//     (acc, curr) => acc + curr.purchase_price,
//     0
//   );

//   return (
//     <Document>
//       <Page style={portraitStyles.page} size="A4" orientation="portrait">
//         {/* Header */}
//         <View style={portraitStyles.header}>
//           <Text style={portraitStyles.reportTitle}>Imei/Serial Report</Text>
//           <Text style={portraitStyles.shopInfo}>
//             ({startDate} to {endDate})
//           </Text>

//           {/* Horizontal Lines */}
//           <View style={portraitStyles.thickDivider} />
//           <View style={portraitStyles.divider} />
//           <View style={portraitStyles.thickDivider} />
//         </View>

//         {/* Table */}
//         <View style={portraitStyles.table}>
//           {/* Table Header */}
//           <View style={portraitStyles.tableRow}>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableColSl]}>Sl.</Text>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableColDate]}>Purchase Date</Text>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableProductName]}>Product Name</Text>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableColImei]}>IMEI/Serial</Text>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableColPurchasePrice]}>Purchase Price</Text>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableColPurchaseInvoice]}>Purchase Invoice</Text>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableColSalePrice]}>Sale Price</Text>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableColSaleInvoice]}>Sale Invoice</Text>
//             <Text style={[portraitStyles.tableColHeader, portraitStyles.tableColVendor]}>Vendor Name</Text>
//           </View>

//           {/* Table Body */}
//           {items.map((report, index) => (
//             <View
//               wrap={false}
//               key={index}
//               style={[
//                 portraitStyles.tableRow,
//                 index % 2 === 0 && portraitStyles.tableRowAlternate,
//               ]}
//             >
//               <Text style={portraitStyles.tableColSl}>{index + 1}</Text>
//               <Text style={portraitStyles.tableColDate}>{report?.date || "N/A"}</Text>
//               <Text style={portraitStyles.tableProductName}>
//                 {`${report?.product_name || "N/A"} ${report?.color || ""} ${report?.storage || ""} ${report?.battery_life ? `(${report.battery_life}%)` : ""}`}
//               </Text>
//               <Text style={portraitStyles.tableColImei}>{report?.imei?.slice(0, 16) || "N/A"}</Text>
//               <Text style={portraitStyles.tableColPurchasePrice}>{report?.purchase_price?.toLocaleString() || 0}</Text>
//               <Text style={portraitStyles.tableColPurchaseInvoice}>{report.purchase_invoice?.replace(/-/g, "")?.slice(-6) || "N/A"}</Text>
//               <Text style={portraitStyles.tableColSalePrice}>{report?.sale_price?.toLocaleString() || 0}</Text>
//               <Text style={portraitStyles.tableColSaleInvoice}>{report.sale_invoice?.replace(/-/g, "")?.slice(-6) || "N/A"}</Text>
//               <Text style={portraitStyles.tableColVendor}>{report?.vendor_name || "N/A"}</Text>
//             </View>
//           ))}

//           {/* Grand Total Row */}
//           <View style={[portraitStyles.tableRow, portraitStyles.grandTotalRow]}>
//             <Text style={portraitStyles.tableProductName}>Grand Total</Text>
//             <Text style={portraitStyles.grandTotalRow}>
//               {purchasePriceTotal > 0
//                 ? purchasePriceTotal.toFixed(2).toLocaleString()
//                 : purchasePriceTotal.toLocaleString()}
//             </Text>
//           </View>
//         </View>

//         {/* Footer */}
//         <View style={portraitStyles.footer}>
//           <Text>Prepared by</Text>
//           <Text>Checked/Recommended by</Text>
//           <Text>Authorized by</Text>
//         </View>
//       </Page>
//     </Document>
//   );
// };

// export default ImeiReportPrintPagePortrait;




import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// Styles
const styles = StyleSheet.create({
  page: {
    paddingVertical: 15,
    paddingHorizontal: 15,
    fontFamily: "Helvetica",
    fontSize: 9,
  },

  // Header
  headerContainer: {
    alignItems: "center",
    marginBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingBottom: 4,
  },
  // logo: { width: 50, height: 50, objectFit: "contain", marginBottom: 3 },
  shopName: { fontSize: 12, fontWeight: "bold", marginBottom: 2 },
  shopDetails: { fontSize: 9, marginBottom: 1 },

  // Title
  titleBlock: { textAlign: "center", marginVertical: 2 },
  reportTitle: { fontSize: 11, fontWeight: "bold", marginBottom: 2 },
  dateRange: { fontSize: 9, marginBottom: 2 },
  thickDivider: { borderBottomWidth: 2, borderBottomColor: "#000" },

  // Table
  table: { display: "table", width: "100%", marginTop: 4 },
  tableRow: { flexDirection: "row" },
  tableHeader: {
    backgroundColor: "#E7EBF4",
    borderWidth: 0.5,
    borderColor: "#000",
    fontWeight: "bold",
  },
  tableCell: {
    padding: 3,
    borderWidth: 0.5,
    borderColor: "#000",
    fontSize: 8,
  },
  sl: { flex: 0.4, textAlign: "center" },
  date: { flex: 1, textAlign: "center" },
  product: { flex: 2, textAlign: "left" },
  imei: { flex: 1.5, textAlign: "left" },
  purchase: { flex: 1, textAlign: "right" },
  pinvoice: { flex: 1, textAlign: "center" },
  sale: { flex: 1, textAlign: "right" },
  sinvoice: { flex: 1, textAlign: "center" },
  vendor: { flex: 1, textAlign: "center" },
  altRow: { backgroundColor: "#F8F8F8" },
  totalRow: {
    backgroundColor: "#E7EBF4",
    fontWeight: "bold",
    flexDirection: "row",
  },

  // Footer
  footer: {
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    fontSize: 9,
  },
});

const ImeiReportPrintPagePortrait = ({ reports, startDate, endDate, today }) => {
  const user = JSON.parse(localStorage.getItem("user")) || {};

  const items = Object.entries(reports ?? {}).flatMap(([_, arr]) => arr);

  const purchasePriceTotal = items.reduce(
    (acc, curr) => acc + (curr.purchase_price || 0),
    0
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.headerContainer}>
          {/* {user?.invoice_settings?.shop_logo && (
            <Image src={user.invoice_settings.shop_logo} style={styles.logo} />
          )} */}

          {user?.invoice_settings?.shop_name && (
            <Text style={styles.shopName}>{user.invoice_settings.shop_name}</Text>
          )}
          {user?.email && <Text style={styles.shopDetails}>Email: {user.email}</Text>}
          {user?.address && <Text style={styles.shopDetails}>Address: {user.address}</Text>}
          {today && <Text style={styles.shopDetails}>Date: {today}</Text>}
          {user?.phone && <Text style={styles.shopDetails}>Mobile: {user.phone}</Text>}
        </View>

        {/* Title */}
        <View style={styles.titleBlock}>
          <Text style={styles.reportTitle}>IMEI/Serial Report</Text>
          <Text style={styles.dateRange}>
            ({startDate} to {endDate})
          </Text>
        </View>

        <View style={styles.thickDivider} />

        {/* Table */}
        <View style={styles.table}>
          {/* Header */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.tableCell, styles.sl]}>Sl</Text>
            <Text style={[styles.tableCell, styles.date]}>Purchase Date</Text>
            <Text style={[styles.tableCell, styles.product]}>Product Name</Text>
            <Text style={[styles.tableCell, styles.imei]}>IMEI/Serial</Text>
            <Text style={[styles.tableCell, styles.purchase]}>Purchase Price</Text>
            <Text style={[styles.tableCell, styles.pinvoice]}>Purchase Invoice</Text>
            <Text style={[styles.tableCell, styles.sale]}>Sale Price</Text>
            <Text style={[styles.tableCell, styles.sinvoice]}>Sale Invoice</Text>
            <Text style={[styles.tableCell, styles.vendor]}>Vendor</Text>
          </View>

          {/* Body */}
          {items.map((report, i) => (
            <View
              key={i}
              style={[styles.tableRow, i % 2 === 0 ? styles.altRow : null]}
            >
              <Text style={[styles.tableCell, styles.sl]}>{i + 1}</Text>
              <Text style={[styles.tableCell, styles.date]}>
                {report?.date || ""}
              </Text>
              <Text style={[styles.tableCell, styles.product]}>
                {[
                  report?.product_name,
                  report?.color,
                  report?.storage,
                  report?.battery_life ? `(${report.battery_life}%)` : null,
                  report?.region ? `(${report.region})` : null,
                  report?.box_status ? `(${report.box_status})` : null,
                ]
                  .filter(Boolean)
                  .join(" ")}
              </Text>
              <Text
                style={[
                  styles.tableCell,
                  styles.imei,
                  {
                    backgroundColor: report?.sale_return_id
                      ? "rgba(34,197,94,0.3)"        // transparent green
                      : report?.purchase_return_id
                      ? "rgba(250,204,21,0.3)"       // transparent yellow
                      : "transparent",
                  },
                ]}
              >
                {report?.imei || ""}
              </Text>
              <Text style={[styles.tableCell, styles.purchase]}>
                {report?.purchase_price
                  ? report.purchase_price.toLocaleString()
                  : ""}
              </Text>
              <Text style={[styles.tableCell, styles.pinvoice]}>
                {report?.purchase_invoice
                  ? report.purchase_invoice.replace(/-/g, "").slice(-6)
                  : ""}
              </Text>
              <Text style={[styles.tableCell, styles.sale]}>
                {report?.sale_price ? report.sale_price.toLocaleString() : ""}
              </Text>
              <Text style={[styles.tableCell, styles.sinvoice]}>
                {report?.sale_invoice
                  ? report.sale_invoice.replace(/-/g, "").slice(-6)
                  : ""}
              </Text>
              <Text style={[styles.tableCell, styles.vendor]}>
                {report?.vendor_name || ""}
              </Text>
            </View>
          ))}

          {/* Total */}
          <View style={[styles.tableRow, styles.totalRow]}>
            <Text style={[styles.tableCell, styles.product]}>Grand Total</Text>
            <Text style={[styles.tableCell, styles.purchase]}>
              {purchasePriceTotal ? purchasePriceTotal.toLocaleString() : ""}
            </Text>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Prepared by</Text>
          <Text>Checked by</Text>
          <Text>Authorized by</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ImeiReportPrintPagePortrait;
